<template>
    <div class="w1400 mb50">
        <div class="logo_box flex-box">
            <router-link to="/">
                <img src="../../../assets/static/images/jj_logo_new.png" class="c_logo" alt="">
            </router-link>
            <div class="fs18 col04 flex-box">物流详情</div>
        </div>
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/Order">我的订单<span class="plr5">/</span></router-link>
            <div class="now_page">物流信息</div>
        </div>

        <div class="box post_box flex-box" v-if="orderInfo.freight_type == 2">
            <img src="../../../assets/static/icon/c_poster.png" class="poster" alt="">
            
            <!-- <div class="tel flex-box fs20 col27 fwb">电话：{{ logistics.contact_mobile }}</div> -->
            <div class="fs16 col9 ml45">
                <div class="mb15">联系人：{{ logistics.contact_name }}</div>
                <div >联系电话：{{ logistics.contact_mobile }}</div>
            </div>
        </div>
        <div class="box log_box" v-else>
            <div class="log_title flex-box fs20 col04">
                <!-- 物流 -->
                <div class="fwb mr15">{{ logistics.express_name }}</div>
                <div class="mr30">{{ logistics.express_no }}</div>
                <div class="cursor col12 fwb" @click="bindCopy(logistics.express_no)">复制</div>
            </div>
            <template v-if="orderInfo.freight_type == 1">
                <div class="fs20 col04 fwb title">物流信息</div>
                <div class="log_list">
                    <div class="item" :class="(index == 0 ? 'active' : '')" v-for="(item, index) in logistics.logistics"
                        :key="index">
                        <i></i>
                        <div class="fs14 mb20">【{{ item.status }}】{{ item.context }}</div>
                        <div class="fs12">{{ item.date }} {{ item.time }}</div>
                    </div>
                </div>
            </template>
        </div>
        <div class="box info_box mt15">
            <div class="fs18 col04 fwb mb15">商品信息</div>
            <div class="title_box flex-box fs14 col04 tc">
                <div class="box1">商品</div>
                <div class="box2">规格</div>
                <div class="box3">单价(元)</div>
                <div class="box4">优惠</div>
                <div class="box5">数量</div>
                <div class="flex-grow-1 tc">小计(元)</div>
            </div>
            <div class="goods_box flex-box fs14" v-for="(goods, index) in orderInfo.items" :key="index">
                <div class="box1 flex-box">
                    <img :src="goods.goods_image" class="pic" alt="">
                    <div class="flex-grow-1 pl30">{{ goods.goods_title }}</div>
                </div>
                <div class="box2 tc">{{ goods.goods_sku_text }}/{{ goods.goods_unit }}</div>
                <div class="box3 tc col90">{{ goods.goods_price }}</div>
                <div class="box4 flex-box flex-center coleb cheap">{{ goods.discount_fee }}</div>
                <div class="box5 tc col27">× {{ goods.goods_num }}</div>
                <div class="flex-grow-1 tc coleb fwb">{{ goods.pay_fee }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "物流详情-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    data() {
        return {
            orderInfo: {
                freight_type: 0,
                items: []
            },
            logistics: {
                express_name: '',
                express_no: '',
                logistics: []
            },
        };
    },
    created() {
        this.orderSn = this.$route.query.id;
        this.fetchExpress();
    },
    methods: {
        fetchExpress() {
            this.$api.OrderExpress({ order_id: this.orderSn, showToast: true }).then(ret => {
                this.orderInfo = ret.data.order;
                ret.data.package.logistics = ret.data.logistics;
                this.logistics = ret.data.package;
                
            }).catch(err => {
                this.$confirm(err.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(ret => {
                    this.$router.go(-1);
                })
            })
        },
         bindCopy(textToCopy) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    this.$message({
                        customClass: 'custom-message',
                        message: '内容已复制',
                        type: 'success'
                    })
                    // this.$alert('内容已复制');
                }).catch((error) => {
                    this.$alert('复制失败');
                    console.error('复制失败：', error);
                });
        },
    },
}
</script>

<style lang="less" scoped>
.logo_box {
    height: 150px;

    .c_logo {
        width: 170px;
        display: block;
        margin: 0 60px 0 16px;
    }

    .fs18::before {
        display: block;
        content: "";
        width: 2px;
        height: 100px;
        background: rgba(98, 134, 171, 0.4);
        margin-right: 60px;
    }
}

.page_location {
    margin: 26px 0 24px;
    padding-bottom: 0;
}

.box {
    background: #fff;
}

.info_box {
    padding: 42px 44px 45px;
    margin-bottom: 14px;

    .title_box {
        width: 1312px;
        height: 68px;
        background: #FAFCFF;
    }

    .goods_box {
        height: 192px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);
    }

    .box1 {
        width: 473px;

        .pic {
            width: 144px;
            height: 144px;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid rgba(98, 134, 171, 0.2);
            margin-left: 44px;
        }

        span {
            width: 43px;
            height: 20px;
            background: linear-gradient(153deg, #FF4D4D 0%, #FF652D 100%);
            border-radius: 5px;
            display: inline-block;
            line-height: 20px;
            text-align: center;
            margin-right: 10px;
        }
    }

    .box2 {
        width: 164px;
    }

    .box3 {
        width: 148px;
    }

    .box4 {
        width: 200px;

        &.cheap::before {
            display: block;
            content: "";
            width: 11px;
            height: 20px;
            background: url('../../../assets/static/icon/c_cheap.png') no-repeat center;
            background-size: 100%;
            margin-right: 7px;
        }
    }

    .box5 {
        width: 200px;
    }
}

.log_box {

    .log_title {
        height: 100px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);

        &::before {
            content: "";
            display: block;
            width: 38px;
            height: 38px;
            background: url('../../../assets/static/icon/c_box.png') no-repeat center;
            background-size: 100%;
            margin: 0 24px 0 44px;
        }
    }

    .title {
        padding-left: 44px;
        margin-top: 43px;
    }

    .log_list {
        padding: 0 642px 50px 44px;
        margin-top: 27px;
        margin-left: 47px;

        .item {
            padding-bottom: 33px;
            border-bottom: 1px solid #e7e7e7;
            position: relative;
            margin-left: 105px;
            line-height: 1;
            color: #bcbcbc;
            padding-top: 38px;

            i {
                width: 12px;
                height: 12px;
                background: #D8D8D8;
                border-radius: 50%;
                position: absolute;
                left: -110px;
                top: 38px;
            }

            &::before {
                content: "";
                display: block;
                width: 2px;
                height: 100%;
                background: #D8D8D8;
                position: absolute;
                left: -105px;
                top: 48px;
            }

            &.active .fs18 {
                color: #272727;
            }

            &.active i,
            &.active::before {
                background: #FFCC3B;
            }

            &.active::after {
                content: "";
                display: block;
                width: 22px;
                height: 22px;
                background: #FFCC3B;
                opacity: 0.4;
                border-radius: 50%;
                position: absolute;
                left: -115px;
                top: 33px;
            }

            &:last-child::before {
                display: none;
            }
        }
    }
}

.post_box {
    width: 1400px;
    height: 117px;
    background: #FFFFFF;
    border-radius: 8px;
    padding-left: 44px;

    .poster {
        width: 73px;
        height: 73px;
        border-radius: 50%;
        margin-right: 18px;
    }

    .colb9 {
        color: #b9b9b9;
    }

    .tel {
        margin-left: 255px;
        cursor: pointer;

        &::before {
            content: "";
            display: block;
            width: 32.5px;
            height: 33px;
            background: url('../../../assets/static/icon/c_tel.png') no-repeat center;
            background-size: 100%;
            margin-right: 15px;
        }
    }
}
</style>